import type { CSV_ERRORS } from 'Components/pages/VehiclesList/FiltersHeader/BulkBidding/error.helpers';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { POPUP_APPEAR } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingProcessingFailed = (errorType: (typeof CSV_ERRORS)[keyof typeof CSV_ERRORS]): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { label: errorType },
		name: 'dlr_bulk_bidding_processing_failed',
		schemaName: POPUP_APPEAR.SCHEMA,
		version: POPUP_APPEAR.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
